var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeChargerBooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.241,
    height: 69.242,
    viewBox: "0 0 69.241 69.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_EV_charger_Booking",
    "data-name": "Home EV charger Booking",
    transform: "translate(11.668 11.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(-11.668 -11.67)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.242,
    height: 69.242,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 66.242,
    height: 66.242,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M84.574,75.492h-1.2a3.348,3.348,0,0,0-3.344,3.344,1.474,1.474,0,0,0,1.47,1.472h1.2a3.348,3.348,0,0,0,3.344-3.344A1.473,1.473,0,0,0,84.574,75.492Z",
    transform: "translate(-43.291 -40.838)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M43.235,75.492h-1.2a1.473,1.473,0,0,0-1.47,1.472,3.348,3.348,0,0,0,3.344,3.344h1.2a1.473,1.473,0,0,0,1.47-1.472A3.349,3.349,0,0,0,43.235,75.492Z",
    transform: "translate(-21.943 -40.838)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M65.577,83.613H57.816a.491.491,0,1,0,0,.983h7.763a.491.491,0,1,0,0-.983Z",
    transform: "translate(-31.008 -45.231)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M65.577,75.727H57.816a.491.491,0,1,0,0,.983h7.763a.491.491,0,1,0,0-.983Z",
    transform: "translate(-31.008 -40.965)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M79.781,56.95a.49.49,0,1,0,.692-.694l-3.82-3.816a.491.491,0,0,0-.694.694Z",
    transform: "translate(-41.011 -28.29)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M75.281,61.748a.49.49,0,1,0,.692-.694L73.837,58.92a.491.491,0,0,0-.694.694Z",
    transform: "translate(-39.487 -31.796)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M15.346,49.574H12.961l1.555-2.534a.49.49,0,0,0-.836-.513l-2.012,3.28a.493.493,0,0,0,.418.746H14.4l-1.8,2.536a.494.494,0,0,0,.4.775.488.488,0,0,0,.4-.206l2.349-3.308a.494.494,0,0,0-.4-.775Z",
    transform: "translate(-6.271 -25.044)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M43.711,31.816,43.259,30.5a2.919,2.919,0,0,0,2.566-3.527,2.436,2.436,0,0,0-2.392-1.913H41.393l-.17-.495A4.41,4.41,0,0,0,37.05,21.58H35.762v-6.6h2.977a.493.493,0,0,0,.289-.886l-6.5-4.759V1.474a.491.491,0,0,0-.491-.491H27.4a.491.491,0,0,0-.491.491V5.227L19.9.1a.492.492,0,0,0-.579,0L.2,14.092a.493.493,0,0,0,.289.886H3.463v4.408H2.651a.491.491,0,0,0-.491.491V30.2a.491.491,0,0,0,.491.491h.812V41.029a.491.491,0,0,0,.983,0V30.686H6.952v6.2a.491.491,0,0,0,.491.491H15.6v1.775a3.437,3.437,0,0,0,1.964,3.1v1.79a1.865,1.865,0,0,0,1.863,1.863H21.7a1.865,1.865,0,0,0,1.863-1.863v-1.46H37.809v1.46a1.865,1.865,0,0,0,1.863,1.863h2.27a1.865,1.865,0,0,0,1.863-1.863V42.252a3.437,3.437,0,0,0,1.964-3.1V35.943a3.423,3.423,0,0,0-.577-1.906Zm-6.662-9.255A3.434,3.434,0,0,1,40.3,24.88l2.285,6.664-23.788,0,2.285-6.664a3.433,3.433,0,0,1,3.247-2.32ZM16.671,8.471a2.943,2.943,0,1,1,2.943,2.943A2.946,2.946,0,0,1,16.671,8.471ZM3.141,29.706V20.367h8.6v9.339ZM15.6,35.944v.45H7.933V30.686h4.3a.491.491,0,0,0,.491-.491l0-10.318a.491.491,0,0,0-.491-.491H4.445V14.978H34.781v6.6H24.325a4.412,4.412,0,0,0-4.175,2.982l-.17.495H17.939a2.438,2.438,0,0,0-2.392,1.913A2.921,2.921,0,0,0,18.113,30.5l-.45,1.314L16.18,34.038a3.423,3.423,0,0,0-.577,1.906ZM44.79,39.15A2.455,2.455,0,0,1,42.339,41.6h-23.3a2.454,2.454,0,0,1-2.451-2.453V35.944A2.453,2.453,0,0,1,17,34.583l1.372-2.057H43.006l1.372,2.057a2.449,2.449,0,0,1,.412,1.361Z",
    transform: "translate(0.001 -0.002)",
    fill: "#00b26b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChargerBooking);
export default __webpack_public_path__ + "static/media/HomeChargerBooking.c64ec4e78f9722b334d864940450cb64.svg";
export { ForwardRef as ReactComponent };